var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-col w-full bg-white shadow-sm hover:shadow-xl mb-5 transition delay-75 duration-200 ease-in-out",
      class: _vm.optionalClasses,
    },
    [
      _c(
        "div",
        { staticClass: "flex w-full flex-wrap", class: _vm.bgClasses },
        [_vm._t("default")],
        2
      ),
      _vm.$scopedSlots.footer
        ? _c(
            "div",
            {
              staticClass:
                "flex w-full justify-between items-center border-t border-opacity-5",
              class: _vm.actionBarStyles,
            },
            [_vm._t("footer")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }